export const GET_CLASSIFICATIONS = 'GET_CLASSIFICATIONS'
export const GET_CLASSIFICATIONS_SUCCESS = 'GET_CLASSIFICATIONS_SUCCESS'
export const GET_CLASSIFICATIONS_FAIL = 'GET_CLASSIFICATIONS_FAIL'

export const ADD_CLASSIFICATIONS = 'ADD_CLASSIFICATIONS'
export const ADD_CLASSIFICATIONS_SUCCESS = 'ADD_CLASSIFICATIONS_SUCCESS'
export const ADD_CLASSIFICATIONS_FAIL = 'ADD_CLASSIFICATIONS_FAIL'

export const UPDATE_CLASSIFICATIONS = 'UPDATE_CLASSIFICATIONS'
export const UPDATE_CLASSIFICATIONS_SUCCESS = 'UPDATE_CLASSIFICATIONS_SUCCESS'
export const UPDATE_CLASSIFICATIONS_FAIL = 'UPDATE_CLASSIFICATIONS_FAIL'

export const DELETE_CLASSIFICATIONS = 'DELETE_CLASSIFICATIONS'
export const DELETE_CLASSIFICATIONS_SUCCESS = 'DELETE_CLASSIFICATIONS_SUCCESS'
export const DELETE_CLASSIFICATIONS_FAIL = 'DELETE_CLASSIFICATIONS_FAIL'

export const SET_CLASSIFICATION_FIELD_ERRORS = 'SET_CLASSIFICATION_FIELD_ERRORS'
